import React from 'react';
import { useLivechatButtonStyles } from './useLivechatButtonStyles';
import { useTheme } from '@gr/ui-neo';
export const LivechatButton = React.forwardRef(({ children, visible, onClick }, ref) => {
    const theme = useTheme();
    const classes = useLivechatButtonStyles({
        theme,
        visible,
    });
    return (React.createElement("button", { "aria-hidden": !visible, type: "button", className: classes['livechat-button'], ref: ref, "data-ats-live-chat-button": "activator", onClick: onClick },
        children,
        React.createElement("svg", { "aria-hidden": true, className: classes['livechat-button-icon'], xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16" },
            React.createElement("path", { fill: "currentColor", d: "M4 15v-3h4l-4 3z" }),
            React.createElement("rect", { width: "14", height: "10", x: "1", y: "2", fill: "currentColor", rx: "2" }))));
});
